import apiService from '@/api/apiService';
import { handleHttpError } from '@/api/errorHandler';

/**
 * 更新資產負債表版本
 * @param {number} id
 * @param {Object} payload
 * @returns {Promise<Object>}
 */
export const updateVersion = async (id, payload) => {
    try {
        const url = `/api/admin/balance/version/${id}`;
        return await apiService.PUT(url, payload);
    } catch (error) {
        throw handleHttpError(error, url, 'PUT');
    }
};
